import { render, staticRenderFns } from "./about-history.vue?vue&type=template&id=c815f434&scoped=true&"
import script from "./about-history.vue?vue&type=script&lang=js&"
export * from "./about-history.vue?vue&type=script&lang=js&"
import style0 from "./about-history.vue?vue&type=style&index=0&id=c815f434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c815f434",
  null
  
)

export default component.exports